/* Free address autocomplete via Photon (photon.komoot.io) — OpenStreetMap-backed.
 * No API key, no signup, no billing. US-restricted results.
 */

const PHOTON_URL = "https://photon.komoot.io/api";

/* Query Photon with a partial address string. */
export async function searchAddresses(q, { country = "us", limit = 5, signal } = {}) {
    if (!q || q.trim().length < 3) return [];
    const params = new URLSearchParams({ q, limit: String(limit), lang: "en" });
    // Restrict to street-address results — filter out generic places.
    params.append("layer", "house");
    params.append("layer", "street");
    if (country) params.append("bbox", "-125,24,-66,50"); // continental US bounding box (approx)
    try {
        const res = await fetch(`${PHOTON_URL}?${params}`, { signal });
        if (!res.ok) return [];
        const data = await res.json();
        return (data.features || [])
            .filter((f) => (f.properties?.countrycode || "").toLowerCase() === country)
            .map((f) => normalize(f));
    } catch (e) {
        if (e.name !== "AbortError") console.warn("[photon] search failed:", e);
        return [];
    }
}

function normalize(feature) {
    const p = feature.properties || {};
    const housenumber = p.housenumber || "";
    const street = p.street || p.name || "";
    const streetLine = `${housenumber} ${street}`.trim();
    const stateCode = US_STATE_TO_CODE[p.state] || "";
    return {
        // Human-readable label used in the dropdown — use 2-letter state code.
        label: [streetLine, p.city, stateCode || p.state, p.postcode].filter(Boolean).join(", "),
        street: streetLine,
        city: p.city || p.locality || "",
        state: p.state || "",
        stateCode,
        zip: p.postcode || "",
        country: (p.countrycode || "us").toUpperCase(),
    };
}

/* Map full state names → USPS 2-letter codes (Photon returns full names). */
const US_STATE_TO_CODE = {
    Alabama: "AL", Alaska: "AK", Arizona: "AZ", Arkansas: "AR", California: "CA",
    Colorado: "CO", Connecticut: "CT", Delaware: "DE", "District of Columbia": "DC",
    Florida: "FL", Georgia: "GA", Hawaii: "HI", Idaho: "ID", Illinois: "IL",
    Indiana: "IN", Iowa: "IA", Kansas: "KS", Kentucky: "KY", Louisiana: "LA",
    Maine: "ME", Maryland: "MD", Massachusetts: "MA", Michigan: "MI", Minnesota: "MN",
    Mississippi: "MS", Missouri: "MO", Montana: "MT", Nebraska: "NE", Nevada: "NV",
    "New Hampshire": "NH", "New Jersey": "NJ", "New Mexico": "NM", "New York": "NY",
    "North Carolina": "NC", "North Dakota": "ND", Ohio: "OH", Oklahoma: "OK", Oregon: "OR",
    Pennsylvania: "PA", "Rhode Island": "RI", "South Carolina": "SC", "South Dakota": "SD",
    Tennessee: "TN", Texas: "TX", Utah: "UT", Vermont: "VT", Virginia: "VA",
    Washington: "WA", "West Virginia": "WV", Wisconsin: "WI", Wyoming: "WY",
};
